import { useCallback, useEffect, useState } from 'react';
import { AccountRequest, IUserService } from '../../features/user/model/interfaces';
import { API_HOST, ResponseCode } from '../../utils/constants';
import { container } from 'tsyringe';
import { useSubject } from '@base/utils/helpers';
import { IPlayer } from '@base/features/player/model/interfaces';
import { IAuthService } from '@base/features/auth/model/interfaces';

export const useAvatar = (player?: IPlayer): [string, boolean, boolean, string] => {
  const authService: IAuthService = container.resolve('authService');
  const userService: IUserService = container.resolve('userService');

  const [avatar, setAvatar] = useState('');
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [typeAvatar, setTypeAvatar] = useState('');
  const [isProcessing, setIsProcessing] = useState(true);
  const [isLoaded, setIsLoaded] = useState(false);
  const session = useSubject(authService.userSession);

  const createCustomAvatarUrl = (apiHost: string, userId: string) => {
    setAvatar(`${apiHost}get_avatar.plx?size=3&uid=${userId}`);
  };

  const createDefaultAvatarUrl = (apiHost: string, id: string) => {
    const idAvatar = Number(id) - 1;
    setAvatar(`/assets/avatars/${idAvatar}.png`);
  };

  const fetchAvatar = useCallback(() => {
    if (!session) return;
    userService
      .getPartAccountInfo(AccountRequest.FACE, session.usr, session.session)
      .then((res) => {
        setIsProcessing(false);
        if (res.code === ResponseCode.SUCCESS) {
          setIsLoaded(true);
          if (res.id === '00' || res.id === '-1') {
            if (res.uploaded) createCustomAvatarUrl(API_HOST, res.uploaded);
          } else {
            if (res.id) createDefaultAvatarUrl(API_HOST, res.id);
          }
        }
      })
      .catch((e) => {
        setIsProcessing(false);
        console.error('Error fething avatar: ', e);
      });
  }, [userService, session]);

  useEffect(() => {
    if (player) {
      //Не смог сделать универсальных хуком, тк для кастомных аватаров player.avatarUrl() позже возвращает актуальные данные
      // setIsProcessing(false);
      // const url = player.avatarUrl();
      //
      // if (url === 'system') {
      //   const sysAvatar = player.avatar;
      //   setAvatar(`assets/images/avatars/${sysAvatar}.png`);
      //   setTypeAvatar(url);
      // } else {
      //   //данные с задержкой(((( player.avatarUrl()
      //   setAvatar(player.avatarUrl());
      //   setTypeAvatar('custom');
      // }
    } else {
      fetchAvatar();
    }
  }, [player, fetchAvatar]);

  return [avatar, isLoaded, isProcessing, typeAvatar];
};
